export default __webpack_public_path__ + "static/logo-42d0a9bfc3a025a4e387ed1cc5d2ddda.svg";